"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var constants_1 = require("../../../../theming/pricing-system/constants");

var dialog_1 = require("../dialog/dialog");

exports.WarningPrompt = function (props) {
  return react_1.default.createElement(dialog_1.Dialog, {
    title: constants_1.WarningPromptContent.promptTitle,
    buttons: props.buttons,
    viewStyle: props.viewStyle,
    type: "prompt"
  }, props.children);
};